/*
This is "Simple Layout"
Gatsby enforces this to be index.js
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { wrapperStyle } from './index.styles';
import { HeaderSimple } from 'inside-out/components/shared/headerSimple';

// Gatsby requires a default export here.
export default class SimpleLayout extends React.PureComponent {
	static propTypes = {
		children: PropTypes.func.isRequired,
		data: PropTypes.shape({
			allContentJson: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							baseTitle: PropTypes.string,
						}),
					})
				),
			}),
		}),
	};

	render() {
		const { baseTitle } = this.props.data.allContentJson.edges[0].node;

		return (
			<div className={wrapperStyle}>
				<Helmet titleTemplate={`${baseTitle} - %s`} />

				<HeaderSimple />

				{this.props.children()}
			</div>
		);
	}
}

export const query = graphql`
	query SimpleLayoutQuery {
		allContentJson(filter: { id: { regex: "\\/site-settings\\.json/" } }) {
			edges {
				node {
					baseTitle
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js